import { faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import DateTimeClock from "src/clinic/components/DateTimeClock";
import LayoutContainer from "src/components/LayoutContainer";
import CisLaboratoryImaging from "./components/services/imaging/CisLaboratoryImaging";
import axios from "axios";
import CisLaboratorySputum from "./components/services/sputum/CisLaboratorySputum";

export default function CisServicesSputum() {
  useEffect(() => {
    axios
      .get(`v1/laboratory/tests`)
      .then(function (response) {
        console.log(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }, []);
  return (
    <LayoutContainer
      icon={<FontAwesomeIcon icon={faImage} color="white" size={"2x"} />}
      title={<h2 className="text-2xl font-bold mb-0">Sputum</h2>}
      subtitle={""}
      titleChildren={
        <div className="ml-auto flex items-center ">
          <div className="px-4 mr-auto">
            <DateTimeClock />
          </div>
        </div>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} lg={12}>
          <CisLaboratorySputum />
        </Grid>
      </Grid>
    </LayoutContainer>
  );
}
